
<div>
    <div class="row">
        <!-- <div class="col-md-6">
            <div class="card card-stats">
                <div class="card-body">                
                    <div class="row">
                        <div class="col">
                            <h5 class="card-title text-uppercase text-muted mb-0">Billing Information</h5>
                            <span class="h2 font-weight-bold mb-0">{{billingAccount.name}}</span>
                            
                            <h5 class="card-title  text-muted mb-0">Email : {{billingAccount.email}} </h5>
                            <h5 class="card-title text-muted mb-0">Phone : {{billingAccount.phone}}</h5>
                        </div>                    
                    </div>
                    <p class="mt-3 mb-0 text-sm">
                        <span class="text-success mr-2">Address : </span>
                        <span class=""> {{billingAccount.address}}</span>
                    </p>        
                </div>
            </div>
        </div> -->
        <div class="col-md-12">
            <div class="card card-stats">
                <div class="card-body">                
                    <div class="row">
                        <div class="col">
                            <h5 class="card-title text-uppercase text-muted mb-0">Invoice Information</h5>
                            <div class="h2 font-weight-bold text-muted mb-0">{{invoice.title}}</div> 
                            <div class="h1">{{this.currency}}{{this.util.numberWithCommas(sumTotal)}}</div>
                        </div>                    
                    </div>
                    <p class="mt-3 mb-0 text-sm">
                        <span class="card-title text-muted mb-0" *ngIf="!invoice.ready; else invoiceReady"><i class="mr-3 fa fa-hourglass-half"></i> Not Ready</span>
                        <ng-template #invoiceReady>
                            <span class="card-title  text-muted mb-0"*ngIf="invoice.paid"><i class="mr-3 fa fa-check-circle text-green"></i> Paid  </span>
                            <span class="card-title text-muted mb-0" *ngIf="!invoice.paid"><i class="mr-3 fa fa-times-circle text-red"></i> Unpaid</span>      
                        </ng-template>
                    </p>        
                    <div class="text-left">
                        <button class="btn btn-success" *ngIf="!invoice.paid" (click)="startPayment()" [disabled]="!invoice.ready"> Pay </button>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table align-items-center table-flush table-hover">
                            <!-- <thead>
                                <tr>
                                    <th colspan="4" class="text-right"> Total : </th><th class="text-right">₦{{this.util.numberWithCommas(sumTotal)}}</th>
                                </tr>
                            </thead> -->
                          <thead class="thead-light">
                            <tr>         
                             <th> Date </th>
                             <th> Number of Students</th>
                             <th> Student Cost </th>
                             <th> Storage </th>
                             <th> Storage Cost </th>
                             <th class="text-right"> Total </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of invoiceItems">
                                <td>{{item.dateString}}</td><td>{{this.util.numberWithCommas(item.numberOfStudents)}}</td><td>{{this.currency}}{{this.util.numberWithCommas(item.numberOfStudentsCost)}}</td><td>{{this.util.numberWithCommas(item.storage)}} GB</td><td>{{this.currency}}{{this.util.numberWithCommas(item.storageCost)}}</td>  <td class="text-right">{{this.currency}}{{this.util.numberWithCommas(item.total)}}</td>
                            </tr>       
                          </tbody>
                          <tfoot>
                            <tr *ngIf="adjustedAmount !== 0">
                                <th colspan="5" class="text-right"> Adjusted Amount : </th><th class="text-right">{{this.currency}}{{this.util.numberWithCommas(adjustedAmount)}}</th>
                            </tr>
                            <tr *ngIf="adjustmentReason">
                                <th colspan="5" class="text-right"> Adjustment Reason : </th><th class="text-right">{{adjustmentReason}}</th>
                            </tr>
                            <tr>
                                <th colspan="5" class="text-right"> Total : </th><th class="text-right">{{this.currency}}{{this.util.numberWithCommas(sumTotal)}}</th>
                            </tr>
                            <tr>
                              <th colspan="7" class="text-right"><button class="btn btn-success" *ngIf="!invoice.paid" [disabled]="!invoice.ready" (click)="startPayment()"> Pay </button></th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                </div>
            </div>
           
        </div>
    </div>
    <app-paymentiframe #payment [loadingPayment]="loadingPayment"></app-paymentiframe>
</div>

